import styled, { css } from 'styled-components/macro'
import Box from 'components/shared/Box'

interface BungalowFeatureWrapperProps {
    hasBorderBottom: boolean
}

export const BungalowFeatureWrapper = styled(Box)<BungalowFeatureWrapperProps>`
    min-width: 100% !important;
    ${({ hasBorderBottom }) =>
        hasBorderBottom &&
        css`
            border-bottom: 2px solid
                ${({ theme }) => theme.colors.grayscale_200};
            padding-bottom: 16px;
            margin-bottom: 8px;
        `}
`
